import { useMemo, type ReactNode } from 'react'
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles'
import { useAppData } from '../contexts/AppDataContext'
import { buildEventPalette } from './eventTheme'

/**
 * Applies the current event's brand colors on top of the base theme, only for
 * the attendee experience it wraps. Falls back to the base (Vericast) theme
 * when the event defines no custom colors.
 */
export default function EventThemeProvider({ children }: { children: ReactNode }) {
  const base = useTheme()
  const { event } = useAppData()

  const themed = useMemo(() => {
    const override = buildEventPalette(event?.primaryColor, event?.accentColor)
    if (!override) return base
    return createTheme(base, {
      palette: {
        primary: { ...base.palette.primary, ...override.primary },
        ...(override.secondary
          ? { secondary: { ...base.palette.secondary, ...override.secondary } }
          : {}),
      },
    })
  }, [base, event?.primaryColor, event?.accentColor])

  return <ThemeProvider theme={themed}>{children}</ThemeProvider>
}
